import { mapProps } from 'recompose';
import OrdersList from '../components/OrdersList';

const UpcomingOrdersHOC = mapProps(({ upcomingOrders, ...rest }) => ({
  ...rest,
  orders: upcomingOrders,
}));

export default UpcomingOrdersHOC(OrdersList);
